import React from "react";
import { KPITeamGroup } from "../Edit/KPITeamGroup";
import {
  KPISectionGoalListItem,
  KPISectionListItem,
} from "./KPISectionListItem";
import { SectionSubItemContainer } from "./SectionSubItemContainer";

import { AHSeparator, Box, useLayoutContext } from "arkh";

export function KPITeamGroupGoalItem({
  item,
  isFirst,
  isLast,
  setSelectedTeams,
  goalDirection,
}: {
  isFirst?: boolean;
  isLast?: boolean;
  goalDirection: "greater" | "less";
  item: KPITeamGroup;
  setSelectedTeams(
    update: ((sections: KPITeamGroup[]) => KPITeamGroup[]) | KPITeamGroup[]
  ): void;
}) {
  const layout = useLayoutContext();
  return (
    <Box
      cornerRadiusTopLeft={isFirst ? "large" : "none"}
      cornerRadiusTopRight={isFirst ? "large" : "none"}
      cornerRadiusBottomLeft={isLast ? "large" : "none"}
      cornerRadiusBottomRight={isLast ? "large" : "none"}
      color="surface"
      space="none"
      style={{
        flexDirection: "column",
        overflow: "hidden",
        borderWidth: 1,
        borderTopWidth: isFirst ? 1 : 0,
        borderBottomWidth: isLast ? 1 : 0,
      }}
      borderColor="border-primary"
    >
      {item.subTeams.length === 0 ? (
        <KPISectionGoalListItem
          team={{
            id: item.teamId,
            name: item.name,
            icon: item.icon,
            color: item.color,
          }}
          setGoalValue={(goalValue) => {
            setSelectedTeams((selectedTeams) =>
              selectedTeams.map((teamGroup) =>
                teamGroup.teamId === item.teamId
                  ? { ...teamGroup, goalValue }
                  : teamGroup
              )
            );
          }}
          goalValue={item.goalValue}
          goalDirection={goalDirection}
        />
      ) : (
        <KPISectionListItem
          team={{
            id: item.teamId,
            name: item.name,
            icon: item.icon,
            color: item.color,
          }}
          style={{
            paddingBottom: 0,
            minHeight: 0,
          }}
        />
      )}
      {item.subTeams.map((subTeam, index) => (
        <Box
          spaceHorizontal="medium"
          style={{ flexDirection: "row" }}
          key={index}
        >
          <SectionSubItemContainer
            color={item.color}
            isLast={index === item.subTeams.length - 1}
          >
            {index !== 0 ? <AHSeparator /> : null}
            <KPISectionGoalListItem
              goalDirection={goalDirection}
              name={subTeam.name}
              goalValue={subTeam.goalValue}
              style={{
                paddingLeft: layout.space.small,
                paddingRight: layout.space.none,
              }}
              setGoalValue={(goalValue) => {
                setSelectedTeams((selectedTeams) =>
                  selectedTeams.map((teamGroup) =>
                    teamGroup.teamId === item.teamId
                      ? {
                          ...teamGroup,
                          subTeams: teamGroup.subTeams.map((s, i) =>
                            i === index
                              ? {
                                  ...s,
                                  goalValue,
                                }
                              : s
                          ),
                        }
                      : teamGroup
                  )
                );
              }}
            />
          </SectionSubItemContainer>
        </Box>
      ))}
    </Box>
  );
}
